import React from 'react';
import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

interface AuthErrorProps {
  message?: string;
}

const AuthError: React.FC<AuthErrorProps> = ({ message = "Your session has expired or you're not authorized to access this resource." }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-md w-full transform transition-all duration-500 hover:shadow-2xl">
        {/* Error header with gradient background */}
        <div className="p-6 bg-gradient-to-r from-purple-500 to-purple-600">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center">
              <Lock className="h-8 w-8 text-purple-500" />
            </div>
          </div>
          <h2 className="mt-4 text-center text-2xl font-bold text-white">Authentication Error</h2>
        </div>
        
        {/* Error details */}
        <div className="p-6">
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-4">
              {message}
            </div>
            
            {/* Error code display */}
            <div className="bg-gray-100 rounded-lg p-3 font-mono text-sm text-center text-gray-700">
              Error Code: AUTH_ERROR
            </div>
          </div>
          
          {/* Action buttons */}
          <div className="flex flex-col space-y-3">
            <Link
              to="/login"
              className="w-full py-3 bg-purple-500 text-white rounded-lg font-medium transition hover:bg-purple-600 flex items-center justify-center space-x-2"
            >
              <span>Sign In</span>
            </Link>
            
            <Link
              to="/"
              className="w-full py-3 bg-gray-200 text-gray-800 rounded-lg font-medium transition hover:bg-gray-300 flex items-center justify-center space-x-2"
            >
              <span>Return to Home</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthError;